import Page404 from "../../components/Page404/Page404";

export default function Pagina404(){
    return(
        <div>
            <Page404 />
        </div>
    )
}